<template>
  <div>
    <div v-if="!selectTestPackFlag" class="sa-mob-cont">
      <button class="sa-btn-back" @click="goBack">
        <i class="icon-arrow-left"></i>
      </button>
      <div class="sa-mob-cont-padbt">
        <h5 class="sa-card-tit sa-ref-tit">Select Test and Package</h5>
        <!-- <span class="sa-clear sa-h-sm-up">Clear all</span> -->
        <div class="sa-tabs sa-test-pack-tab">
          <a
            v-on:click="tabSelection = 'tests'"
            v-bind:class="[tabSelection === 'tests' ? 'active' : '']"
            class="sa-sprite sa-test-pack"
            >Tests</a
          >
          <a
            v-on:click="tabSelection = 'packages'"
            v-bind:class="[tabSelection === 'packages' ? 'active' : '']"
            class="sa-sprite sa-packages"
            >Packages</a
          >
        </div>
        <div class="sa-tab-cont" :tabSelection="tabSelection">
          <div class="sa-card" v-if="tabSelection === 'tests'">
            <div v-if="loader">
              <img
                src="../../../../../src/assets/img/loader.svg"
                alt="loader"
                class="sa-loader"
              />
            </div>
            <div class="sa-row">
              <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg3">
                <div class="sa-form-group">
                  <input
                    @input="getTests()"
                    type="text"
                    class="sa-form-control sa-dark-search"
                    id="searchName"
                    name="Search Name"
                    v-model="searchName"
                    placeholder="Search Test"
                  /><i class="icon-search sa-search"></i>
                </div>
              </div>
            </div>
            <div class="sa-test-pack-check">
              <div
                class="sa-form-group"
                v-for="(test, index) in tests"
                :key="index"
              >
                <input
                  type="checkbox"
                  :id="index"
                  v-model="selectTest"
                  :value="test"
                  :name="index"
                />
                <!-- <input type="checkbox"  :id="index" v-model="selectTest" :value="test" :name="index"> -->
                <label :for="index">{{ test.tst_nm }}</label>
              </div>
            </div>
          </div>
          <template v-if="tabSelection === 'packages'">
            <swiper
              class="swiper sa-test-pack"
              ref="swiper"
              :options="swiperOption"
            >
              <swiper-slide v-for="(pkg, ix) in packages" :key="ix">
                <input
                  @change="selectedPackage(pkg)"
                  type="checkbox"
                  :id="ix"
                  :name="pkg.pkg_nm"
                  :value="pkg"
                  v-model="selectPakage"
                />
                <label :for="ix">
                  <figure>
                    <img
                      :src="pkg && pkg.pkg_img ? pkg.pkg_img : unknownImg"
                      alt="Doctor"
                      class="sa-img-cover"
                    />
                  </figure>
                  <div class="sa-test-pack-cnt">
                    <h5>{{ pkg.pkg_nm }}</h5>
                    <small>({{ pkg.tst_nm.length }} test incl)</small>
                  </div>
                </label>
              </swiper-slide>
            </swiper>
            <div
              class="swiper-button-prev"
              slot="button-prev"
              @click="prev()"
            ></div>
            <div
              class="swiper-button-next"
              slot="button-next"
              @click="next()"
            ></div>
            <div
              class="sa-card sa-card-gray sa-card-noshadow sa-test-slct-cnt"
              v-if="packTests && packTests.length"
            >
              <strong>Test Include in this Package</strong>
              <ul class="sa-unorder-list">
                <li v-for="(t, i) in packTests" :key="i">{{ t }}</li>
              </ul>
            </div>
          </template>
        </div>
      </div>
      <div class="sa-text-right sa-ftr-btn sa-mt40">
        <button
          class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs"
          @click="SelectContinue"
        >
          Continue
        </button>
      </div>
    </div>
    <test-package-view :packages="selectPakage" :tests="selectTest" v-else />
  </div>
</template>
<script>
import TestPackageViewVue from "./TestPackageView.vue";
import _ from "lodash";
import { pro_url } from "../../../../../config/endpoints";
import async from "async";
export default {
  props: ["tst_id", "pkg_id"],
  components: {
    "test-package-view": TestPackageViewVue,
  },
  data() {
    return {
      packTests: [],
      unknownImg: "https://img.litedev.com/images/unkown-img.svg",
      tests: [],
      selectTest: [],
      selectPakage: [],
      packages: [],
      searchName: "",
      radio: 1,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          414: {
            slidesPerView: 2.5,
            spaceBetween: 10,
          },
          375: {
            slidesPerView: 1.5,
            spaceBetween: 8,
          },
        },
      },
      tabSelection: "tests",
      checked: false,
      clinicInfoReq: "",
      selectTestFlag: false,
      selectTestPackFlag: false,
      loader: false,
    };
  },
  mounted() {
    if (this.tst_id && this.tst_id.length > 0) {
      _.map(this.tst_id, (e) => {
        e.tst_id = e.id;
        e.tst_nm = e.name;
        delete e.id;
        delete e.name;
      });
    }
    // if(this.pkg_id && this.pkg_id.length > 0){
    //   _.map(this.pkg_id, e => {
    //     console.log(this.packages,'dddd');
    //      let obj = this.packages.find(r => e.id == r.pkg_id)
    //      console.log(obj);
    //     e.pkg_id = e.id
    //     e.pkg_nm = e.name
    //     delete e.id
    //     delete e.name
    //   })
    // }
    this.selectTest = this.tst_id ? this.tst_id : [];
    // this.selectPakage = this.pkg_id ? this.pkg_id : []
    // this.selectPakage = {
    //   pkg_id : this.pkg_id[0].id,
    //   pkg_nm : this.pkg_id[0].name
    // }
    // console.log(this.selectPakage,'aa');
    let _self = this;
    async.parallel(
      [_self.getTests.bind(), _self.getPackages.bind()],
      function () {}
    );
  },
  methods: {
    goBack() {
      //console.log('object');
      this.$parent.referLabTech = false;
      this.$parent.getReferralData();
    },
    selectedPackage(pkg) {
      this.packTests = pkg.tst_nm;
    },
    getTests() {
      let _self = this;
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/treatmentDetails`,
          body: {
            mtype: 1,
            limit: 1000,
            page: 1,
            name: _self.searchName,
            prd_id: "ST04",
          },
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.loader = false;
            _self.tests = response.data.data;
          }
        });
    },
    getPackages() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/treatmentDetails`,
          body: {
            mtype: 2,
            limit: 1000,
            page: 1,
            name: "",
            prd_id: "ST04",
          },
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.packages = response.data.data;
            // console.log( _self.packages,'pkg');
            if (_self.pkg_id && _self.pkg_id.length) {
              if (this.pkg_id && this.pkg_id.length > 0) {
                _.map(this.pkg_id, (e) => {
                  // console.log(this.packages,'dddd');
                  let obj = this.packages.find((r) => e.id == r.pkg_id);
                  this.selectPakage.push(obj);
                  delete e.id;
                  delete e.name;
                });
              }
              // _self.pkg_id = _self.pkg_id[0]
              // _.map(this.packages, e => {
              //  // console.log(e.pkg_id);

              //   if(e.pkg_id == _self.pkg_id){
              //     _self.selectPakage = e
              //     return e
              //   }
              // })
              // let selectedPackage = _self.packages.filter(pack => pack.pkg_id == _self.pkg_id)
              // if (selectedPackage && selectedPackage[0]) {
              //   _self.selectedPackage(selectedPackage[0])
              // }
            }
          }
        });
    },
    SelectContinue() {
      let _self = this;
      if (!_self.selectTestFlag) {
        _self.selectTestFlag = true;
        _self.selectTestPackFlag = true;
      } else {
        _self.selectTestFlag = false;
        _self.selectTestPackFlag = false;
      }
    },
    selectTestPack() {
      let _self = this;
      let test = [];
      let pkg = [];
      console.log(_self.selectPakage, "ssssssss");
      if (typeof _self.pkg_id == "string") {
        _self.pkg_id = [_self.pkg_id];
      }
      // if(_self.selectPakage && _self.selectPakage.pkg_id){
      //   _self.pkg_id = [_self.selectPakage.pkg_id]
      // }
      console.log(this.selectTest);
      if (this.selectPakage && this.selectPakage.length > 0) {
        _.map(this.selectPakage, (pkgs) => {
          pkg.push(pkgs.pkg_id);
        });
      }
      if (this.selectTest && this.selectTest.length > 0) {
        _.map(this.selectTest, (tst) => {
          test.push(tst.tst_id);
        });
      }
      _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"));
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/addTreatmentReferal`,
          body: {
            apnt_id: _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            uid: _self.patDetails.refDoctor || "",
            stid: _self.patDetails.stid || "",
            dept_id: _self.patDetails.dept_id || "",
            pkg_id: pkg,
            tsk_id: _self.patDetails.refNurse || [],
            tst_id: test,
            trtmnt_id: _self.patDetails.refPhysio || [],
            ref_doctorId: _self.patDetails.ref_doctorId || "",
          },
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.loader = false;
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Updated tests and packages referrals successfully",
              class: "sa-a-success",
            });
            _self.patDetails.refTests = _self.tst_id;
            _self.patDetails.refPackages = _self.pkg_id;
            _self.$localStorage.set(
              "patDetails",
              JSON.stringify(_self.patDetails)
            );
            // if(!_self.selectTestFlag) {
            //   _self.selectTestFlag = true
            //   _self.selectTestPackFlag = true
            // }else {
            //   _self.selectTestFlag = false
            //   _self.selectTestPackFlag = false
            // }
            this.goBack();
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
              class: "sa-a-danger",
            });
          }
        });
    },
    prev() {
      this.$refs.swiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.swiper.$swiper.slideNext();
    },
  },
};
</script>
